import React, { ReactElement } from 'react';

import { MenuItemGroup as RCMenuItemGroup } from 'rc-menu';

import { IMenuItemGroupProps } from './MenuItemGroup.types';

const MenuItemGroup = ({ children, ...rest }: IMenuItemGroupProps): ReactElement => (
  <RCMenuItemGroup {...rest}>{children}</RCMenuItemGroup>
);

export default MenuItemGroup;
